import { SUPPORTED_LANGUAGES } from '@kiku/config/constants';

const displayNames = new Intl.DisplayNames(['en'], { type: 'language' });

export const LANGUAGES = SUPPORTED_LANGUAGES.map((code) => {
  const name = displayNames.of(code) ?? code.toUpperCase();
  return { code, label: name.charAt(0).toUpperCase() + name.slice(1) };
}).sort((a, b) => a.label.localeCompare(b.label));
